import React, { useState, useEffect, useRef, forwardRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
class ThuChiNgoaiLePrint extends React.Component {

    renderTableData() {

        if (typeof this.props.dataPrint.List != "undefined") {
            return this.props.dataPrint.List.map((item, i) => {
                return (
                    <tr>
                        <td style={{ border: "1px solid #EEE", textAlign: "center" }}>
                            <div>{i + 1}</div>
                        </td>
                        <td style={{ border: "1px solid #EEE", textAlign: "left" }}>
                            {getDate(item.Time)}
                        </td>
                        <td style={{ border: "1px solid #EEE", }}>
                            {item.ThuChiCode}
                        </td>
                        <td style={{ border: "1px solid #EEE", }}>
                            {item.userFullName}
                        </td>
                        <td style={{ border: "1px solid #EEE", }}>
                            {item.Name}
                        </td>
                        <td style={{ border: "1px solid #EEE" }}>
                            {item.TypeName}
                        </td>
                        <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
                            {item.Value >= 0 && (
                                formatNumber(item.Value)
                            )}
                            {item.Value < 0 && (<span>0</span>)}
                        </td>
                        <td style={{ border: "1px solid #EEE", textAlign: "right" }}>
                            {item.Value <= 0 && (
                                formatNumber(-1 * item.Value)
                            )}
                            {item.Value > 0 && (<span>0</span>)}
                        </td>
                    </tr>
                );
            });
        }

    }

    render() {

        return (
            <>
                <div id={this.props.dataPrint.TypeName}>
                    <table style={{ width: "90%", margin: "0 auto" }} >
                        <tr>
                            <td style={{ textAlign: "center", width: "100%", fontWeight: "bold", fontSize: "18px", color: "#000000" }}>
                                <br />
                                DANH SÁCH THU/CHI NGOÀI LỀ
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: "center", width: "100%", fontWeight: "bold", fontSize: "14px", color: "#000000" }}>
                                Từ ngày: {this.props.dataPrint.TuNgay} - Đến ngày: {this.props.dataPrint.DenNgay}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: "left", width: "100%", fontWeight: "bold", fontSize: "14px", color: "#000000" }}>
                                {this.props.dataPrint.TongTienThuBangChu}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ textAlign: "left", width: "100%", fontWeight: "bold", fontSize: "14px", color: "#000000" }}>
                                {this.props.dataPrint.TongTienChiBangChu}
                            </td>
                        </tr >
                        <tr>
                            <td style={{ height: "20px" }}></td>
                        </tr>
                    </table>
                    <table style={{ border: "1px solid #EEE", width: "95%", color: "#000000", margin: "0 auto" }} >
                        <tr>
                            <th style={{ border: "1px solid #EEE", textAlign: "center" }}>
                                <div>STT</div>
                                <span>[ {this.props.dataPrint.TongBanGhi} ]</span>
                            </th>
                            <th style={{ border: "1px solid #EEE" }}>
                                <div>Ngày</div>
                            </th>
                            <th style={{ border: "1px solid #EEE" }}>
                                Mã phiếu
                            </th>
                            <th style={{ border: "1px solid #EEE" }}>
                                Nhân viên
                            </th>
                            <th style={{ border: "1px solid #EEE" }}>
                                Người nhận / Người nộp tiền
                            </th>
                            <th style={{ border: "1px solid #EEE" }}>
                                Loại phiếu
                            </th>
                            <th style={{ border: "1px solid #EEE", textAlign: "right" }}>
                                <div>Thu ngoài lề</div>
                                <span>{(this.props.dataPrint.TongThu)}</span>
                            </th>
                            <th style={{ border: "1px solid #EEE", textAlign: "right" }}>
                                <div>Chi ngoài lề</div>
                                <span>{(this.props.dataPrint.TongChi)}</span>
                            </th>
                        </tr>

                        {this.renderTableData()}
                    </table >
                </div>

            </>
        );
    }


}
export default ThuChiNgoaiLePrint;